import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type PatientState = {
  url: string;
};

const slice = createSlice({
  name: 'patient',
  initialState: { url: '' } as PatientState,
  reducers: {
    setUrl(state, action: PayloadAction<Partial<string>>) {
      state.url = action.payload;
    },
  },
});

export default slice.reducer;

export const { setUrl } = slice.actions;
